/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I store these buffers?`)
};

const es_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo almacenar estos buffers?`)
};

const de_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich diese Puffer lagern?`)
};

const nl_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik deze buffers bewaren?`)
};

const fr_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je conserver ces tampons ?`)
};

const it_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso conservare questi buffer?`)
};

const pt_br2_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso armazenar esses tampões?`)
};

const pt_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso armazenar estes tampões?`)
};

const ja_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらのバッファーは保存できますか?`)
};

const zh_buf_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些缓冲液可以保存吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_q4", locale)
	if (locale === "en") return en_buf_faq_q4(inputs)
	if (locale === "es") return es_buf_faq_q4(inputs)
	if (locale === "de") return de_buf_faq_q4(inputs)
	if (locale === "nl") return nl_buf_faq_q4(inputs)
	if (locale === "fr") return fr_buf_faq_q4(inputs)
	if (locale === "it") return it_buf_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_q4(inputs)
	if (locale === "pt") return pt_buf_faq_q4(inputs)
	if (locale === "ja") return ja_buf_faq_q4(inputs)
	return zh_buf_faq_q4(inputs)
};